/**
 * 车轮战 H5 管理端 / C 端 API
 */

import request from '@/utils/request'
import { pickWheelBattleApiDetail } from '@/views/match-manage/wheel-battle/utils/jersey-colors'

function pickCreateParentGamePayload(params) {
  var input = params || {}
  var payload = {
    matchId: input.matchId,
    stageId: input.stageId,
    groupId: input.groupId,
    beginDate: input.beginDate,
    teamOrder: input.teamOrder
  }
  if (input.name) {
    payload.name = input.name
  }
  if (input.endDate) {
    payload.endDate = input.endDate
  }
  if (input.fieldId) {
    payload.fieldId = input.fieldId
  }
  if (input.location) {
    payload.location = input.location
  }
  return payload
}

function pickUpdateParentGamePayload(params) {
  var input = params || {}
  var payload = {
    gameId: input.gameId
  }
  if (input.name) {
    payload.name = input.name
  }
  if (input.beginDate) {
    payload.beginDate = input.beginDate
  }
  if (input.endDate) {
    payload.endDate = input.endDate
  }
  if (input.fieldId !== undefined && input.fieldId !== null && input.fieldId !== '') {
    payload.fieldId = input.fieldId
  }
  if (input.location !== undefined && input.location !== null) {
    payload.location = input.location
  }
  if (input.teamOrder) {
    payload.teamOrder = input.teamOrder
  }
  return payload
}

function pickCreateChildGamePayload(params) {
  var input = params || {}
  var payload = {
    gameId: input.gameId
  }
  if (input.homeTeamId) {
    payload.homeTeamId = String(input.homeTeamId)
  }
  if (input.awayTeamId) {
    payload.awayTeamId = String(input.awayTeamId)
  }
  if (input.restartConfirmed !== undefined && input.restartConfirmed !== null && input.restartConfirmed !== '') {
    payload.restartConfirmed = input.restartConfirmed
  }
  return payload
}

function normalizeRequestError(defaultMsg) {
  return function () {
    return { error: 'requestFailed', msg: defaultMsg }
  }
}

/**
 * AdminGetBMMatchStageGroupList
 */
export function adminGetBMMatchStageGroupList(params) {
  return request({
    url: '/bmmatch/AdminGetBMMatchStageGroupList',
    method: 'GET',
    params: params
  })
}

/**
 * AdminUpdateBMMatchStageGroupTeams
 * 更新阶段小组球队及顺序；车轮战会同步未开始父场次的初始轮转顺序
 */
export function adminUpdateBMMatchStageGroupTeams(params) {
  var input = params || {}
  return request({
    url: '/bmmatch/AdminUpdateBMMatchStageGroupTeams',
    method: 'POST',
    data: {
      matchId: input.matchId,
      stageId: input.stageId,
      groupId: input.groupId,
      teamIds: input.teamIds
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '保存失败，请稍后重试' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('保存失败，请稍后重试'))
}

/**
 * AdminCreateBMMatchWheelBattleParentGame
 */
export function adminCreateBMMatchWheelBattleParentGame(params) {
  return request({
    url: '/bmmatch/AdminCreateBMMatchWheelBattleParentGame',
    method: 'POST',
    data: pickCreateParentGamePayload(params)
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed' }
    }
    return { data: res.data }
  }).catch(normalizeRequestError('创建失败，请稍后重试'))
}

/**
 * AdminGetBMMatchWheelBattleParentGame
 */
export function adminGetBMMatchWheelBattleParentGame(params) {
  return request({
    url: '/bmmatch/AdminGetBMMatchWheelBattleParentGame',
    method: 'GET',
    params: {
      gameId: params && params.gameId
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '加载失败' }
    }
    return { data: pickWheelBattleApiDetail(res) }
  }).catch(normalizeRequestError('加载失败'))
}

/**
 * GetBMMatchWheelBattleParentGame（C 端）父场次详情
 */
export function getBMMatchWheelBattleParentGame(params) {
  return request({
    url: '/bmmatch/GetBMMatchWheelBattleParentGame',
    method: 'GET',
    params: {
      gameId: params && params.gameId
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '加载失败' }
    }
    return { data: pickWheelBattleApiDetail(res) }
  }).catch(normalizeRequestError('加载失败'))
}

/**
 * AdminUpdateBMMatchWheelBattleParentGame
 */
export function adminUpdateBMMatchWheelBattleParentGame(params) {
  return request({
    url: '/bmmatch/AdminUpdateBMMatchWheelBattleParentGame',
    method: 'POST',
    data: pickUpdateParentGamePayload(params)
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '保存失败，请稍后重试' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('保存失败，请稍后重试'))
}

/**
 * AdminUpdateBMMatchWheelBattleParentGameTeamClothesColor 更新单支球队队服颜色
 */
export function adminUpdateBMMatchWheelBattleParentGameTeamClothesColor(params) {
  var input = params || {}
  return request({
    url: '/bmmatch/AdminUpdateBMMatchWheelBattleParentGameTeamClothesColor',
    method: 'POST',
    data: {
      gameId: input.gameId,
      teamId: input.teamId,
      clothesColor: input.clothesColor != null ? input.clothesColor : ''
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '保存队服颜色失败' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('保存队服颜色失败'))
}

/**
 * AdminDeleteBMMatchWheelBattleParentGame
 */
export function adminDeleteBMMatchWheelBattleParentGame(params) {
  return request({
    url: '/bmmatch/AdminDeleteBMMatchWheelBattleParentGame',
    method: 'POST',
    data: {
      gameId: params && params.gameId
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '删除失败' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('删除失败'))
}

function pickConfirmChildGameResultPayload(params) {
  var input = params || {}
  return {
    gameId: input.gameId,
    homeScore: input.homeScore,
    awayScore: input.awayScore
  }
}

/**
 * AdminConfirmBMMatchWheelBattleChildGameResult 确认子场次比分
 */
export function adminConfirmBMMatchWheelBattleChildGameResult(params) {
  return request({
    url: '/bmmatch/AdminConfirmBMMatchWheelBattleChildGameResult',
    method: 'POST',
    data: pickConfirmChildGameResultPayload(params)
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '提交失败，请稍后重试' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('提交失败，请稍后重试'))
}

/**
 * AdminUpdateBMMatchWheelBattleChildGameResult 修改已完赛子场次比分
 */
export function adminUpdateBMMatchWheelBattleChildGameResult(params) {
  return request({
    url: '/bmmatch/AdminUpdateBMMatchWheelBattleChildGameResult',
    method: 'POST',
    data: pickConfirmChildGameResultPayload(params)
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '提交失败，请稍后重试' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('提交失败，请稍后重试'))
}

/**
 * AdminDeleteBMMatchWheelBattleChildGame 删除子场次
 */
export function adminDeleteBMMatchWheelBattleChildGame(params) {
  return request({
    url: '/bmmatch/AdminDeleteBMMatchWheelBattleChildGame',
    method: 'POST',
    data: {
      gameId: params && params.gameId
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '删除失败' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('删除失败'))
}

/**
 * AdminFinishBMMatchWheelBattleParentGame 结束父场次
 */
export function adminFinishBMMatchWheelBattleParentGame(params) {
  return request({
    url: '/bmmatch/AdminFinishBMMatchWheelBattleParentGame',
    method: 'POST',
    data: {
      gameId: params && params.gameId
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '操作失败，请稍后重试' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('操作失败，请稍后重试'))
}

/**
 * AdminRestartBMMatchWheelBattleParentGame 已结束父场次重启
 */
export function adminRestartBMMatchWheelBattleParentGame(params) {
  return request({
    url: '/bmmatch/AdminRestartBMMatchWheelBattleParentGame',
    method: 'POST',
    data: {
      gameId: params && params.gameId
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '重启失败，请稍后重试' }
    }
    return { data: res.data || { update: res.update } }
  }).catch(normalizeRequestError('重启失败，请稍后重试'))
}

/**
 * AdminGetBMMatchWheelBattleChildGame 子场次详情
 */
export function adminGetBMMatchWheelBattleChildGame(params) {
  return request({
    url: '/bmmatch/AdminGetBMMatchWheelBattleChildGame',
    method: 'POST',
    data: {
      gameId: params && params.gameId
    }
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '加载失败' }
    }
    return { data: res.data }
  }).catch(normalizeRequestError('加载失败'))
}

/**
 * AdminCreateBMMatchWheelBattleChildGame
 */
export function adminCreateBMMatchWheelBattleChildGame(params) {
  return request({
    url: '/bmmatch/AdminCreateBMMatchWheelBattleChildGame',
    method: 'POST',
    data: pickCreateChildGamePayload(params)
  }).then(function (res) {
    if (!res) {
      return { error: 'requestFailed', msg: '创建失败，请稍后重试' }
    }
    var data = res.data || res
    return {
      data: {
        id: data.id
      }
    }
  }).catch(normalizeRequestError('创建失败，请稍后重试'))
}
